import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Vacante } from '../../../core/models/vacante.model';
import { seniorityLabel, ubicacionTexto, paisSlug } from '../../../core/utils/vacante-labels';

@Component({
  selector: 'app-job-card',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './job-card.component.html',
})
export class JobCardComponent {
  @Input({ required: true }) vacante!: Vacante;

  get ubicacionTexto(): string {
    return ubicacionTexto(this.vacante.ciudad, this.vacante.pais);
  }

  get seniorityLabel(): string {
    return seniorityLabel(this.vacante.seniority);
  }

  get detalleLink(): string[] {
    return ['/vacantes', paisSlug(this.vacante.pais), this.vacante.urlSlug];
  }

  get salarioTexto(): string | null {
    const v = this.vacante;
    if (!v.salarioMin && !v.salarioMax) return null;
    const moneda = v.monedaSalario ?? 'MXN';
    const format = (n: number) => n.toLocaleString('es-MX');
    if (v.salarioMin && v.salarioMax) {
      return `${moneda} $${format(v.salarioMin)} - $${format(v.salarioMax)}`;
    }
    return `${moneda} $${format(v.salarioMin ?? v.salarioMax ?? 0)}`;
  }
}
